/* eslint-disable */

<template>
  <div>
    <vx-card class="mb-base">
      <div :style="{'display': firewall_one === true ? '' : 'none!important'}" class="firewall-popup-block-2">
        <div class="eleventh-block mb-2">
          <h1 class="tenth-block-text">Firewall</h1><img draggable="false"
          alt="" class="image-49 cursor-pointer-simulation"
          src="https://rapidsimulations.com/simulations/1/images/cancel.png"
          width="30" @click="firewall_one = false">
        </div>
        <div class="tenth-line-firewall"></div>
        <div class="tenth-table-block ">
          <div class="tenth-table-header-2 mb-2">
            <div class="vx-row p-2">
              <div class="vx-col w-2/12">
                <h3 class="font-bold">Rule #</h3>
              </div>
              <div class=" vx-col w-2/12">
                <h3 class="font-bold ">Source</h3>
              </div>
              <div class="vx-col w-2/12">
                <h3 class="font-bold ">Destination</h3>
              </div>
              <div class=" vx-col w-2/12">
                <h3 class="font-bold ">Port<br></h3>
              </div>
              <div class=" vx-col w-2/12">
                <h3 class="font-bold ">Protocol<br></h3>
              </div>
              <div class="vx-col w-2/12">
                <h3 class="font-bold ">Action<br></h3>
              </div>
            </div>
          </div>
          <div class="tenth-table-body">
            <div v-for="answer in firewall_one_answers" class="vx-row p-2" :key="answer.rule">
              <div class="vx-col w-2/12">
                <h5>{{ answer.rule }}</h5>
              </div>
              <div class=" vx-col w-2/12">
                <select :id="'source'+answer.rule" class="ninth-select w-select">
                  <option v-for="item in source_options" :key="item">{{ item }}
                  </option>
                </select>
              </div>
              <div class=" vx-col w-2/12">
                <select :id="'dest'+answer.rule" class="ninth-select w-select ">
                  <option v-for="item in source_options" :key="item">{{ item }}
                  </option>
                </select>
              </div>
              <div class=" vx-col w-2/12">
                <input :id="'port'+answer.rule" class="text-field-tenth w-input bg-white" required type="text">
              </div>
              <div class=" vx-col w-2/12">
                <select :id="'protocol'+answer.rule" class="ninth-select w-select">
                  <option v-for="item in protocol_options" :key="item">{{ item }}
                  </option>
                </select>
              </div>
              <div class=" vx-col w-2/12">
                <select :id="'action'+answer.rule" class="ninth-select w-select">
                  <option v-for="item in action_options" :key="item">{{ item }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="simulation-10">
        <div class="vx-row my-4">
          <div class="vx-col w-3/12 center-2"></div>
          <div class="vx-col w-3/12 center-2"></div>
          <div class="vx-col w-6/12 center-2">
            <div class="tenth-public-network">
              <h1 class="tenth-block-text">Public Server Network</h1>
              <div class="tenth-public-network-bottom">
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false" alt="" class="tenth-image"
                                                      src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                                                      width="60"></div>
                  <h1 class="tenth-block-text-small">Mail Server<br>192.168.10.2</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false" alt="" class="tenth-image"
                                                      src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                                                      width="60"></div>
                  <h1 class="tenth-block-text-small">DNS&nbsp;Server<br>192.168.10.3</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false" alt="" class="tenth-image"
                                                      src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                                                      width="60"></div>
                  <h1 class="tenth-block-text-small">App Server<br>192.168.10.4</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false" alt="" class="tenth-image"
                                                      src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                                                      width="60"></div>
                  <h1 class="tenth-block-text-small">Web Server<br>192.168.10.5</h1>
                </div>
              </div>
            </div>
            <div class="fw-line-2-656"></div>
          </div>
        </div>
        <div class="vx-row my-4">
          <div class="vx-col w-3/12 center-2">
            <div class="tenth-internet-block-2">
              <div class="tenth-image-block"><img draggable="false"
                alt=""
                class="tenth-image"
                src="https://cdn.discordapp.com/attachments/746242308084858900/793710470267011102/global.png"
                width="60"></div>
              <h1 class="tenth-internet-text">Internet</h1>
            </div>
          </div>
          <div class="vx-col w-3/12 center-2">
            <div class="tenth-firewall-block-2 cursor-pointer-simulation" @click="firewall_one = !firewall_one">
              <div class="tenth-image-block"><img draggable="false"
                alt=""
                class="tenth-image"
                src="https://cdn.discordapp.com/attachments/746242308084858900/793709704307933224/wall-2.png"
                width="60"></div>
              <h1 class="tenth-internet-text">Firewall</h1>
            </div>
            <div class="fw-line-1-656"></div>
            <div class="line-internet-up"></div>
          </div>
          <div class="vx-col w-6/12 center-2">
            <div class="tenth-secure-network-block">
              <h1 class="tenth-block-text">Secure Network</h1>
              <div class="tenth-public-network-bottom">
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681991215742976/server-2_1.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Financial Server<br>&zwj;192.168.100.10</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681991215742976/server-2_1.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Purchasing Server<br>&zwj;192.168.100.18</h1>
                </div>
              </div>
            </div>
            <div class="fw-line-2-656"></div>
          </div>
        </div>
        <div class="vx-row my-4">
          <div class="vx-col w-3/12 center-2"></div>
          <div class="vx-col w-3/12 center-2"></div>
          <div class="vx-col w-6/12 center-2">
            <div class="tenth-secure-workstation-block">
              <h1 class="tenth-block-text">Workstation Network</h1>
              <div class="tenth-public-network-bottom">
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Accounting<br>10.10.9.12</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Human Resources<br>10.10.9.14</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Sales<br>10.10.9.16</h1>
                </div>
                <div class="tenth-block">
                  <div class="tenth-image-block"><img draggable="false"
                    alt=""
                    class="tenth-image"
                    src="https://cdn.discordapp.com/attachments/746242308084858900/793681764413210624/database_1_2.png"
                    width="60"></div>
                  <h1 class="tenth-block-text-small">Admin<br>10.10.9.18</h1>
                </div>
              </div>
            </div>
            <div class="fw-line-2-656"></div>
          </div>
        </div>

      </div>
    </vx-card>
  </div>
</template>

<script>

import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      firewall_one: false,


      current_page: 0,

      source_options: [
        '192.168.10.2/32',
        '10.10.9.12/32',
        '10.10.9.18/32',
        '192.168.100.18/32',
        '192.168.10.4/32',
        '192.168.10.3/32',
        '192.168.100.10/32',
        '10.10.9.18/32',
        '10.10.9.14/32',
        '10.10.9.16/32',
        '192.168.10.5/32'
      ],

      dest_options: [
        '192.168.10.3/32',
        '192.168.100.18/32',
        '10.10.9.0/28',
        '192.168.10.0/29',
        '192.168.10.4/32',
        '192.168.100.10/32',
        '192.168.100.10/32',
        '10.10.9.12/32',
        '192.168.100.18/32',
        '192.168.10.2/32',
        '10.10.9.18/32',
        '10.10.9.16/32',
        '192.168.100.0/28',
        '10.10.9.14/32',
        '192.168.10.5/32'
      ],

      protocol_options: [
        'ANY',
        'UDP',
        'TCP'
      ],

      action_options: [
        'PERMIT',
        'DENY'
      ],

      firewall_one_answers: [
        {
          'rule': '1',
          'port': '443',
          'source': '10.10.9.12/32',
          'destination': '192.168.10.5/32',
          'protocol': 'TCP',
          'action': 'PERMIT'
        },
        {
          'rule': '2',
          'port': '22',
          'source': '10.10.9.14/32',
          'destination': '192.168.100.10/32',
          'protocol': 'TCP',
          'action': 'PERMIT'
        },
        {
          'rule': '3',
          'port': '69',
          'source': '10.10.9.18/32',
          'destination': '192.168.100.10/32',
          'protocol': 'UDP',
          'action': 'PERMIT'
        },
        {
          'rule': '4',
          'port': '69',
          'source': '10.10.9.18/32',
          'destination': '192.168.100.18/32',
          'protocol': 'UDP',
          'action': 'PERMIT'
        }
      ]

    }
  },
  methods: {
    show_firewall () {
      this.firewall_one = true
    },
    markSimulation () {

      let total_score = 0

      this.firewall_one_answers.forEach(x => {
        if (x.source === document.getElementById(`source${x.rule}`).value) {
          document.getElementById(`source${x.rule}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`source${x.rule}`).style.backgroundColor = '#fd4445'
        }
        if (x.destination === document.getElementById(`dest${x.rule}`).value) {
          document.getElementById(`dest${x.rule}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`dest${x.rule}`).style.backgroundColor = '#fd4445'
        }
        if (x.port === document.getElementById(`port${x.rule}`).value) {
          document.getElementById(`port${x.rule}`).classList.remove('bg-white')
          document.getElementById(`port${x.rule}`).classList.remove('bg-danger-custom')
          document.getElementById(`port${x.rule}`).classList.add('bg-success-custom')
          total_score++
        } else {
          document.getElementById(`port${x.rule}`).classList.remove('bg-white')
          document.getElementById(`port${x.rule}`).classList.remove('bg-success-custom')
          document.getElementById(`port${x.rule}`).classList.add('bg-danger-custom')
        }
        if (x.protocol === document.getElementById(`protocol${x.rule}`).value) {
          document.getElementById(`protocol${x.rule}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`protocol${x.rule}`).style.backgroundColor = '#fd4445'
        }
        if (x.action === document.getElementById(`action${x.rule}`).value) {
          document.getElementById(`action${x.rule}`).style.backgroundColor = '#77FAAE'
          total_score++
        } else {
          document.getElementById(`action${x.rule}`).style.backgroundColor = '#fd4445'
        }
      })

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/views/simulations/legacy/css/CompTIA/Security+/Lgx184768857066438656.scss";

</style>

